/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_File_TitleInputs */

const en_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import File`)
};

const fr_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer un Fichier`)
};

const de_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importdatei`)
};

const it_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa file`)
};

const ru_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт файла`)
};

const es_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar archivo`)
};

const zh_cn2_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入文件`)
};

const ja_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのインポート`)
};

const hi_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात फ़ाइल`)
};

const pt_pt2_toolbar_secondary_import_file_title = /** @type {(inputs: Toolbar_Secondary_Import_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de importação`)
};

/**
* | output |
* | --- |
* | "Import File" |
*
* @param {Toolbar_Secondary_Import_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_file_title = /** @type {((inputs?: Toolbar_Secondary_Import_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_import_file_title(inputs)
	if (locale === "de") return de_toolbar_secondary_import_file_title(inputs)
	if (locale === "it") return it_toolbar_secondary_import_file_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_import_file_title(inputs)
	if (locale === "es") return es_toolbar_secondary_import_file_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_import_file_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_import_file_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_import_file_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_import_file_title(inputs)
	return en_toolbar_secondary_import_file_title(inputs)
});